import { render } from "./Breadcumnd.vue?vue&type=template&id=5e24cb91"
import script from "./Breadcumnd.vue?vue&type=script&lang=js"
export * from "./Breadcumnd.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__